import { useAuth } from "@/hooks/useAuth";
import { fetchValidPassesData } from "@/services/passes.queries";
import { useToastNotify } from "@/stores/toastStore";
import { useUiModulesStore } from "@/stores/uiModulesStore";
import { useQuery } from "@tanstack/react-query";
import { useT } from "@transifex/react";
import { useState } from "react";

export const useValidPasses = () => {
  const { user } = useAuth();
  const { notify } = useToastNotify();
  const [errorNotified, setErrorNotified] = useState(false);
  const flexPassUiModule = useUiModulesStore((state) => state.flexPassUiModule);
  const t = useT();

  const enableQuery = flexPassUiModule && !!user?.idToken && user?.idToken.length > 0;

  const { data, isFetching, isError, error, refetch } = useQuery({
    queryKey: ["valid-passes", user?.idToken],
    queryFn: () => fetchValidPassesData({ cognitoIDToken: user?.idToken ?? "" }),
    enabled: enableQuery,
    retry: false,
  });

  if (isError && !errorNotified) {
    notify({
      severity: "error",
      message: t("An error occurred when fetching valid passes data"),
    });
    console.error("Error fetching valid passes data:", error);
    setErrorNotified(true);
  }
  if (!isError && errorNotified) {
    setErrorNotified(false);
  }

  return { data, isFetching, refetch };
};
